var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRank1St(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 29,
    viewBox: "0 0 26 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3877 8.63525L24.9417 1.08117C25.1148 0.907817 25.4111 1.03052 25.4111 1.27564V5.41602C25.4111 5.61975 25.3301 5.81509 25.1863 5.95921L19.4956 11.6499C19.4956 11.6499 17.2516 8.77127 17.3877 8.63525Z",
    fill: "url(#paint0_linear_1058_11449)",
    stroke: "#8B9FBE",
    strokeWidth: 0.234208,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3875 14.7398L24.9416 7.18571C25.1147 7.01265 25.411 7.13507 25.411 7.38019V11.5206C25.411 11.7243 25.33 11.9196 25.1862 12.0638L19.4955 17.7544C19.4955 17.7544 17.2515 14.8758 17.3875 14.7398Z",
    fill: "url(#paint1_linear_1058_11449)",
    stroke: "#8B9FBE",
    strokeWidth: 0.234208,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27031 8.63525L0.716225 1.08117C0.542877 0.907817 0.246826 1.03052 0.246826 1.27564V5.41602C0.246826 5.61975 0.327857 5.81509 0.471686 5.95921L6.16236 11.6499C6.16236 11.6499 8.40633 8.77127 8.27031 8.63525Z",
    fill: "url(#paint2_linear_1058_11449)",
    stroke: "#8B9FBE",
    strokeWidth: 0.234208,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27031 14.7398L0.716225 7.18571C0.542877 7.01265 0.246826 7.13507 0.246826 7.38019V11.5206C0.246826 11.7243 0.327857 11.9196 0.471686 12.0638L6.16236 17.7544C6.16236 17.7544 8.40633 14.8758 8.27031 14.7398Z",
    fill: "url(#paint3_linear_1058_11449)",
    stroke: "#8B9FBE",
    strokeWidth: 0.234208,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8292 29C12.198 29 11.5752 28.8333 11.0289 28.5176L4.36234 24.6687C3.25193 24.0274 2.56201 22.8324 2.56201 21.5501V13.8525C2.56201 12.5702 3.25193 11.375 4.36234 10.734L11.0289 6.88503C11.5755 6.56958 12.198 6.40289 12.8292 6.40289C13.4606 6.40289 14.0831 6.56958 14.6295 6.88503L21.296 10.734C22.4064 11.3753 23.0963 12.5702 23.0963 13.8525V21.5501C23.0963 22.8324 22.4064 24.0271 21.296 24.6687L14.6295 28.5176C14.0831 28.8331 13.4604 29 12.8292 29Z",
    fill: "url(#paint4_linear_1058_11449)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8292 28.7659C12.2392 28.7659 11.6569 28.6099 11.1458 28.3148L4.47931 24.4661C3.44096 23.8668 2.7959 22.7494 2.7959 21.5504V13.8525C2.7959 12.6533 3.44096 11.5362 4.47931 10.9369L11.1458 7.0879C11.6569 6.79272 12.2389 6.63702 12.8292 6.63702C13.4193 6.63702 14.0016 6.79301 14.5126 7.0879L21.1789 10.9369C22.2172 11.5362 22.8623 12.6536 22.8623 13.8525V21.5501C22.8623 22.7491 22.2172 23.8662 21.1789 24.4658L14.5126 28.3145C14.0016 28.6097 13.4193 28.7659 12.8292 28.7659Z",
    fill: "#B7493D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09839 13.6989V21.7038C3.09839 22.7037 3.63174 23.6274 4.49761 24.1275L11.4301 28.1299C12.296 28.6296 13.3627 28.6296 14.2285 28.1299L21.161 24.1275C22.0269 23.6277 22.5602 22.7037 22.5602 21.7038V13.6989C22.5602 12.699 22.0269 11.7753 21.161 11.2752L14.2285 7.27285C13.3627 6.77306 12.296 6.77306 11.4301 7.27285L4.49761 11.2752C3.63174 11.7753 3.09839 12.699 3.09839 13.6989Z",
    fill: "url(#paint5_linear_1058_11449)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30176 15.0164V20.3862C6.30176 21.0567 6.65945 21.6766 7.24027 22.012L11.8906 24.697C12.4714 25.0324 13.1871 25.0324 13.7679 24.697L18.4182 22.012C18.999 21.6766 19.3567 21.057 19.3567 20.3862V15.0164C19.3567 14.3456 18.999 13.726 18.4182 13.3906L13.7679 10.7059C13.1871 10.3705 12.4714 10.3705 11.8906 10.7059L7.24027 13.3906C6.65945 13.726 6.30176 14.3459 6.30176 15.0164Z",
    fill: "#B7493D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.72485 15.3113V20.3332C6.72485 20.9603 7.05939 21.54 7.60259 21.8537L11.9516 24.3644C12.4948 24.6782 13.1639 24.6782 13.7071 24.3644L18.0561 21.8537C18.5993 21.54 18.9339 20.9606 18.9339 20.3332V15.3113C18.9339 14.6842 18.5993 14.1045 18.0561 13.7908L13.7071 11.28C13.1639 10.9663 12.4948 10.9663 11.9516 11.28L7.60259 13.7908C7.05939 14.1045 6.72485 14.6842 6.72485 15.3113Z",
    fill: "url(#paint6_linear_1058_11449)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M3.09839 15.0706C5.45117 17.8086 8.93636 19.545 12.8293 19.545C16.7223 19.545 20.2074 17.8086 22.5602 15.0706V13.6989C22.5602 12.699 22.0269 11.7753 21.161 11.2752L14.2285 7.27288C13.3627 6.77281 12.296 6.77281 11.4301 7.27288L4.49761 11.2752C3.63174 11.775 3.09839 12.699 3.09839 13.6989V15.0706Z",
    fill: "url(#paint7_linear_1058_11449)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2313 19.8803H10.7159V18.4354H12.3234V16.0422L10.7159 16.1506V14.7057L12.793 14.2361H14.2198V18.4354H15.2313V19.8803Z",
    fill: "#282844"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2313 19.8803V19.9704C15.2811 19.9704 15.3214 19.9301 15.3214 19.8803H15.2313ZM10.7159 19.8803H10.6258C10.6258 19.9301 10.6661 19.9704 10.7159 19.9704V19.8803ZM10.7159 18.4354V18.3453C10.6661 18.3453 10.6258 18.3856 10.6258 18.4354H10.7159ZM12.3234 18.4354V18.5255C12.3732 18.5255 12.4135 18.4852 12.4135 18.4354H12.3234ZM12.3234 16.0422H12.4135C12.4135 16.0173 12.4032 15.9934 12.3849 15.9764C12.3667 15.9594 12.3422 15.9506 12.3173 15.9523L12.3234 16.0422ZM10.7159 16.1506H10.6258C10.6258 16.1756 10.6361 16.1994 10.6544 16.2164C10.6726 16.2335 10.6971 16.2422 10.722 16.2405L10.7159 16.1506ZM10.7159 14.7057L10.696 14.6178C10.6549 14.6271 10.6258 14.6636 10.6258 14.7057H10.7159ZM12.793 14.2361V14.146C12.7863 14.146 12.7796 14.1467 12.7731 14.1482L12.793 14.2361ZM14.2198 14.2361H14.31C14.31 14.1863 14.2696 14.146 14.2198 14.146V14.2361ZM14.2198 18.4354H14.1297C14.1297 18.4852 14.1701 18.5255 14.2198 18.5255V18.4354ZM15.2313 18.4354H15.3214C15.3214 18.3856 15.2811 18.3453 15.2313 18.3453V18.4354ZM15.2313 19.7902H10.7159V19.9704H15.2313V19.7902ZM10.806 19.8803V18.4354H10.6258V19.8803H10.806ZM10.7159 18.5255H12.3234V18.3453H10.7159V18.5255ZM12.4135 18.4354V16.0422H12.2332V18.4354H12.4135ZM12.3173 15.9523L10.7098 16.0607L10.722 16.2405L12.3294 16.1322L12.3173 15.9523ZM10.806 16.1506V14.7057H10.6258V16.1506H10.806ZM10.7358 14.7936L12.8129 14.324L12.7731 14.1482L10.696 14.6178L10.7358 14.7936ZM12.793 14.3262H14.2198V14.146H12.793V14.3262ZM14.1297 14.2361V18.4354H14.31V14.2361H14.1297ZM14.2198 18.5255H15.2313V18.3453H14.2198V18.5255ZM15.1411 18.4354V19.8803H15.3214V18.4354H15.1411Z",
    fill: "#282844"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2313 19.5779H10.7159V18.133H12.3234V15.7398L10.7159 15.8482V14.4033L12.793 13.9337H14.2198V18.133H15.2313V19.5779Z",
    fill: "#F7FFEC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2313 19.5779V19.668C15.2811 19.668 15.3214 19.6277 15.3214 19.5779H15.2313ZM10.7159 19.5779H10.6258C10.6258 19.6277 10.6661 19.668 10.7159 19.668V19.5779ZM10.7159 18.133V18.0428C10.6661 18.0428 10.6258 18.0832 10.6258 18.133H10.7159ZM12.3234 18.133V18.2231C12.3732 18.2231 12.4135 18.1827 12.4135 18.133H12.3234ZM12.3234 15.7398H12.4135C12.4135 15.7149 12.4032 15.691 12.3849 15.674C12.3667 15.6569 12.3422 15.6482 12.3173 15.6499L12.3234 15.7398ZM10.7159 15.8482H10.6258C10.6258 15.8731 10.6361 15.897 10.6544 15.914C10.6726 15.9311 10.6971 15.9398 10.722 15.9381L10.7159 15.8482ZM10.7159 14.4033L10.696 14.3153C10.6549 14.3246 10.6258 14.3611 10.6258 14.4033H10.7159ZM12.793 13.9337V13.8435C12.7863 13.8435 12.7796 13.8443 12.7731 13.8457L12.793 13.9337ZM14.2198 13.9337H14.31C14.31 13.8839 14.2696 13.8435 14.2198 13.8435V13.9337ZM14.2198 18.133H14.1297C14.1297 18.1827 14.1701 18.2231 14.2198 18.2231V18.133ZM15.2313 18.133H15.3214C15.3214 18.0832 15.2811 18.0428 15.2313 18.0428V18.133ZM15.2313 19.4877H10.7159V19.668H15.2313V19.4877ZM10.806 19.5779V18.133H10.6258V19.5779H10.806ZM10.7159 18.2231H12.3234V18.0428H10.7159V18.2231ZM12.4135 18.133V15.7398H12.2332V18.133H12.4135ZM12.3173 15.6499L10.7098 15.7583L10.722 15.9381L12.3294 15.8297L12.3173 15.6499ZM10.806 15.8482V14.4033H10.6258V15.8482H10.806ZM10.7358 14.4912L12.8129 14.0216L12.7731 13.8457L10.696 14.3153L10.7358 14.4912ZM12.793 14.0238H14.2198V13.8435H12.793V14.0238ZM14.1297 13.9337V18.133H14.31V13.9337H14.1297ZM14.2198 18.2231H15.2313V18.0428H14.2198V18.2231ZM15.1411 18.133V19.5779H15.3214V18.133H15.1411Z",
    fill: "#282844"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1058_11449",
    x1: 21.3152,
    y1: 11.9943,
    x2: 21.5053,
    y2: 0.402823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2F1E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FFEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1058_11449",
    x1: 21.3151,
    y1: 18.0989,
    x2: 21.5051,
    y2: 6.50737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2F1E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FFEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1058_11449",
    x1: 4.3429,
    y1: 11.9943,
    x2: 4.15288,
    y2: 0.402823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2F1E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FFEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1058_11449",
    x1: 4.3429,
    y1: 18.0989,
    x2: 4.15288,
    y2: 6.50737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2F1E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FFEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1058_11449",
    x1: 2.56181,
    y1: 17.7014,
    x2: 23.0964,
    y2: 17.7014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA6B49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB749"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1058_11449",
    x1: 12.8292,
    y1: 28.5048,
    x2: 12.8292,
    y2: 6.89805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA6B49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB749"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1058_11449",
    x1: 12.6811,
    y1: 8.15394,
    x2: 12.9409,
    y2: 25.1037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC249"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEEA49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1058_11449",
    x1: 3.0983,
    y1: 13.2215,
    x2: 22.5602,
    y2: 13.2215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9FFDE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRank1St);
export default __webpack_public_path__ + "static/media/rank-1st.fd96f0480e9b02524dcd1a1d87c5fa5e.svg";
export { ForwardRef as ReactComponent };